export default "__VITE_ASSET__WGkIFebR__"